// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader__card {
    position: absolute;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    z-index: 10;
    pointer-events: auto;
}

.loader__card .flip-container {
    pointer-events: none;
    opacity: .9;
    max-width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/loader-card/loader-card.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".loader__card {\n    position: absolute;\n    top: 0;\n    background-color: rgba(0, 0, 0, 0.2);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    z-index: 10;\n    pointer-events: auto;\n}\n\n.loader__card .flip-container {\n    pointer-events: none;\n    opacity: .9;\n    max-width: 300px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
